import ImagesScrollbarGallery from "@components/ImagesScrollbarGallery";
import Markdown from "@components/Markdown";
import Icons from "@gstyles/styleguide/icons";
import { useTranslationContext } from "@providers/TranslationProvider";
import cx from "classnames";
import "swiper/css/scrollbar";
import styles from "./TheDetails.module.scss";
import { usePageContext } from "@providers/PageProvider";
import getter from "@services/RoomService/getter";
import { roomPage } from "@utils/helper";

interface Props {
  data: any;
}
const components = {
  ul: ({ children }: any) => children,
  li: ({ children }: any) => (
    <div className={cx(styles.item)}>
      <Icons
        name={"check-outline"}
        color="#af915e"
        className={cx(styles.icon)}
      />
      <div className={cx(styles.value)}>{children}</div>
    </div>
  ),
};
export default function TheDetails({}: Props) {
  const { i18n } = useTranslationContext();
  const { pageData } = usePageContext();
  const images: any = roomPage.formatImages(pageData);
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.swiperWrapper)}>
        <ImagesScrollbarGallery
          galleryName={"swiper-room-images"}
          images={images}
        />
      </div>

      <div className={cx(styles.detailSection)}>
        <div className={cx(styles.title)}>{i18n.t("Rooms.theDetails")}</div>
        <div className={cx(styles.content)}>
          <div className={cx(styles.utilGroup)}>
            <div className={cx(styles.labelGroup)}>
              {i18n.t("Rooms.utilities")}
            </div>

            <Markdown
              className={cx(styles.itemsWrapper)}
              components={components}
              content={getter.features(pageData)}
            />

            <div className={cx("flex flex-col mt-auto")}>
              <div className={cx(styles.item)}>
                <Icons
                  name={"clock-outline"}
                  color="#af915e"
                  className={cx(styles.icon)}
                />
                <div className={cx(styles.labelIcon)}>
                  {i18n.t("Rooms.checkIn")}:
                </div>
                <div className={cx(styles.value)}>
                  {getter.checkIn(pageData)}
                </div>
              </div>
              <div className={cx(styles.divider)} />
              <div className={cx(styles.item)}>
                <Icons
                  name={"clock-outline"}
                  color="#af915e"
                  className={cx(styles.icon)}
                />
                <div className={cx(styles.labelIcon)}>
                  {i18n.t("Rooms.checkOut")}:
                </div>
                <div className={cx(styles.value)}>
                  {getter.checkOut(pageData)}
                </div>
              </div>
            </div>
          </div>
          <div className={cx(styles.amenitiesGroup)}>
            <div className={cx(styles.labelGroup)}>
              {i18n.t("Rooms.amenities")}
            </div>

            <Markdown
              className={cx(styles.itemsWrapper)}
              components={components}
              content={getter.amenities(pageData)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
